import ActionTypes from '../action-types';
import { onFulfill, onPending, onReject } from '../util';

const initialState = {
  agentIsVendor: null,
  isAvailable: false,
  isLoading: false,
  jobSow: {
    jobId: null,
    sowId: null,
    isSigned: null,
    isUpdated: null,
    agentSowJson: {}
  },
  profile: {
    phoneNumber: null,
    birthday: null,
    gender: null,
    countryOfLiving: null,
    languages: null
  },
  metrics: {
    callCount: null,
    activeTime: null,
    recordingTime: null
  },
  metricsDuration: 7,
  isProfileIncomplete: false,
  loginErrorMessage: false,
  termsOfUseUpdateAt: null
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case ActionTypes.SET_AVAILABILITY:
      return {
        ...state,
        isAvailable: action.payload
      };

    case onPending(ActionTypes.LOGIN):
      return {
        ...state,
        isProfileIncomplete: false,
        isLoading: true
      };
    case onPending(ActionTypes.SESSION):
    case onPending(ActionTypes.LOGOUT):
    case onPending(ActionTypes.GET_AGENT_TOU_ACCEPTANCE):
    case onPending(ActionTypes.GET_AGENT_IS_VENDOR):
    case onPending(ActionTypes.GET_JOB_AGENT_SOW):
      return {
        ...state,
        isLoading: true
      };

    case onReject(ActionTypes.LOGIN):
    case onFulfill(ActionTypes.LOGIN):
    case onReject(ActionTypes.SESSION):
    case onFulfill(ActionTypes.SESSION):
    case onReject(ActionTypes.LOGOUT):
    case onFulfill(ActionTypes.LOGOUT):
    case onReject(ActionTypes.GET_AGENT_TOU_ACCEPTANCE):
      return {
        ...state,
        loginErrorMessage: action.errorMessage || initialState.loginErrorMessage,
        isProfileIncomplete: action.isProfileIncomplete || initialState.isProfileIncomplete,
        isLoading: false
      };

    case onFulfill(ActionTypes.GET_JOB_AGENT_SOW):
      return {
        ...state,
        jobSow: action.payload,
        isLoading: false
      };

    case onFulfill(ActionTypes.GET_AGENT_IS_VENDOR):
      return {
        ...state,
        agentIsVendor: action.payload,
        isLoading: false
      };

    case onFulfill(ActionTypes.GET_AGENT_TOU_ACCEPTANCE):
    case ActionTypes.SIGN_AGENT_TOU_ACCEPTANCE:
      return {
        ...state,
        termsOfUseUpdateAt: action.payload,
        isLoading: false
      };

    case onFulfill(ActionTypes.GET_AGENT_PROFILE):
      return {
        ...state,
        profile: action.payload
      };

    case onFulfill(ActionTypes.SAVE_AGENT_PHONE_NUMBER):
      return {
        ...state,
        profile: { phoneNumber: action.phoneNumber }
      };

    case onFulfill(ActionTypes.GET_AGENT_METRICS):
      return {
        ...state,
        metrics: {
          callCount: action.payload.agentCallCount,
          activeTime: action.payload.agentActiveTime,
          recordingTime: action.payload.agentRecordingTime
        }
      };
    case ActionTypes.SET_METRICS_DURATION:
      return {
        ...state,
        metricsDuration: action.metricsDuration
      };
    default:
      return state;
  }
};
